@if (sharedPolicyData?.policy !== null) {
  <div class="cds-flex cds-justify-between cds-py-6 cds-items-center cds-w-full">
    <div class="cds-flex cds-flex-col cds-gap-1 md:cds-gap-2">
      <p class="cds-text-mobile-headline-6-roman cds-leading-mobile-headline-6-roman cds-font-desktop-headline-1-light">
        Total Premium
      </p>
      <div class="cds-flex cds-gap-4">
        <p class="body-small md:!body-regular !cds-font-semibold cds-items-center" data-testid="total-premium-value">
          ${{ (sharedPolicyData?.policy?.premium?.amount ?? 0) / 100 | number: '1.2-2' }} per
          {{ _baseGetValByCode('paymentFrequency', sharedPolicyData?.policy?.paymentFrequency) }}
        </p>
        <button
          cbButton
          label="View breakdown & Payment Frequency"
          variant="ghost"
          colorTheme="purple"
          class="!cds-hidden md:!cds-grid !cds-p-0 cds-underline !cds-font-light"
          (click)="handleViewBreakdownModal()"
          data-testid="policy-footer-view-breakdown-button"></button>
      </div>
    </div>
    <div class="cds-hidden md:cds-flex cds-gap-2 cds-mr-[46px] disabled:cds-mr-[86px]">
      <button
        cbButton
        [disabled]="!_baseQuoteHasChanged || openSaveModal || saveInProgress || quoteHasErrors"
        [label]="openSaveModal || saveInProgress ? 'Saving ...' : 'Save Progress'"
        variant="ghost"
        colorTheme="purple"
        iconColor="purple-branding"
        leftIcon="utility-save-stroke"
        (click)="handleSaveProgressModal()"
        data-testid="policy-footer-save-button"></button>
      <button
        cbButton
        label="Return to Dashboard"
        variant="primary"
        colorTheme="purple"
        (click)="backToDashboard()"
        data-testid="policy-footer-dashboard-button"></button>
    </div>
    <div class="!cds-flex md:!cds-hidden cds-items-center cds-pr-2">
      <span cbDropdownMenu label=" " [displayOnClick]="true" colorway="light" labelIcon="utility-ellipses-vt">
        <p-tieredMenu
          appendTo="body"
          #menu
          [model]="footerActionList"
          [popup]="true"
          [autoZIndex]="false"
          data-testid="policy-mobile-footer-menu" />
      </span>
    </div>
  </div>
}
<div>
  <cb-modal
    [open]="open"
    (closeEvent)="handleViewBreakdownModal()"
    title="Cover breakdown & payment frequency"
    [closeOnEscape]="false"
    customContent="true"
    [hideCloseIcon]="false"
    [hideDefaultFooter]="true"
    data-testid="policy-view-breakdown-modal">
    <div>
      <app-premium-breakdown
        [paymentFrequencyOptions]="paymentFrequency"
        [coverageCodeVals]="coverageCodeVals"
        [coverages]="sharedPolicyData?.coverages ?? []"
        [customers]="sharedPolicyData?.customers ?? []"
        [policy]="sharedPolicyData?.policy!"
        [paymentFrequencyLabel]="paymentFrequencyLabel"
        (chosenFrequency)="setChosenPaymentFrequency($event)" />
    </div>
  </cb-modal>
</div>
<div>
  <cb-modal
    [open]="openSaveModal"
    (closeEvent)="handleSaveProgressModal()"
    title="Save progress"
    [closeOnEscape]="false"
    customContent="true"
    [hideCloseIcon]="saveInProgress"
    [hideDefaultFooter]="true"
    data-testid="policy-save-progress-modal">
    <div class="cds-flex cds-flex-col">
      @if (saveInProgress) {
        <div class="cds-flex cds-flex-col cds-justify-center cds-items-center cds-gap-2 cds-h-full">
          <p-progressSpinner />
          <h4 class="cds-my-1 cds-text-center">Saving</h4>
        </div>
      } @else {
        <div
          cbTextArea
          label="For your own reference, add some comments"
          styleVariant="gray-fill"
          characterCountText="Remaining characters"
          colorTheme="default"
          cbTooltip="add comments"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default">
          <textarea
            placeholder="add comments"
            required
            maxLength="200"
            [disabled]="false"
            data-testid="policy-save-progress-modal-comment"
            [formControl]="saveComment"></textarea>
        </div>
        <div class="cds-mt-8 cds-flex cds-justify-end cds-gap-[10px]">
          <button
            cbButton
            label="Back"
            variant="secondary"
            colorTheme="purple"
            data-testid="policy-save-progress-modal-cancel-button"
            (click)="handleSaveProgressModal()"></button>
          <button
            cbButton
            label="Save"
            variant="primary"
            colorTheme="purple"
            data-testid="policy-save-progress-modal-save-comment"
            [disabled]="!saveComment.valid"
            (click)="saveProgress()"></button>
        </div>
      }
    </div>
  </cb-modal>
</div>
